const defaultDeviceFrameAll = [
  // Gondola (0)
  {
    name: "Gondola",
    index: 1,
    gondolaType: "Gondola",
    shelfType: "Standard",
    rowCount: 5,
    columnCount: 2,
    rowWidth: 320,
    isCooler: false,
    isSingleCooler: false,
    isSelected: false,
    head: [],
    foot: [],
    rows: [
      {
        rowIndex: 1,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 2,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 3,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-false",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
      {
        rowIndex: 4,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 5,
        column: [
          {
            shelf: {
              key: "S-false",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
    ],
  },
  //double door cooler (1)
  {
    name: "DoubleCooler",
    index: 4,
    gondolaType: "Cooler",
    shelfType: "GlassDoor",
    rowCount: 5,
    columnCount: 2,
    rowWidth: 320,
    isCooler: true,
    isSingleCooler: false,
    isSelected: false,
    head: [
      {
        camera: {},
      },
    ],
    foot: [],
    rows: [
      {
        rowIndex: 1,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 2,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 3,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
      {
        rowIndex: 4,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
      {
        rowIndex: 5,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
    ],
  },
   //single door cooler (2)
  {
    name: "SingleCooler",
    index: 5,
    gondolaType: "Cooler",
    shelfType: "GlassDoor",
    rowCount: 5,
    columnCount: 1,
    rowWidth: 220,
    isCooler: true,
    isSingleCooler: true,
    isSelected: false,
    head: [
      {
        camera: {},
      },
    ],
    foot: [],
    rows: [
      {
        rowIndex: 1,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 2,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-true",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
          },
        ],
      },
      {
        rowIndex: 3,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
      {
        rowIndex: 4,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
      {
        rowIndex: 5,
        column: [
          {
            shelf: {
              key: "S-true",
              label: "Shelf",
              mac: "276271617161",
              location: "1.2, 3.2, 4.2",
              isOnline: true,
            },
            camera: {
              key: "C-false",
              label: "Camera",
              idValue: "192.168.1.1",
              serialNumber: "276271611234",
              location: "1.2, 3.2, 4.2",
              isOnline: false,
            },
          },
        ],
      },
    ],
  },
   // Smart Cooler Double door (3)
  {
    name: "SmartDoubleCooler",
    index: 2,
    gondolaType: "Smart Cooler",
    shelfType: "Smart",
    rowCount: 5,
    columnCount: 2,
    rowWidth: 320,
    isCooler: true,
    isSingleCooler: false,
    isSelected: false,
    head: [
      {
        shelf: {},
        camera: {
          key: "HCL1",
          label: "HCL",
          idValue: "192.168.1.1",
          serialNumber: "276271611234",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
        rightCamera: {
          key: "HCR1",
          label: "HCR",
          idValue: "192.168.1.2",
          serialNumber: "276271611235",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
      },
      {
        shelf: {},
        camera: {
          key: "HCL2",
          label: "HCL",
          idValue: "192.168.1.3",
          serialNumber: "276271611236",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
        rightCamera: {
          key: "HCR2",
          label: "HCR",
          idValue: "192.168.1.4",
          serialNumber: "276271611237",
          location: "1.2, 3.2, 4.2",
          isOnline: false,
        },
      },
    ],
    foot: [
      {
        shelf: {},
        camera: {
          key: "FCL",
          label: "FCL",
          idValue: "192.168.1.5",
          serialNumber: "276271611238",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
      },
      {
        shelf: {},
        rightCamera: {
          key: "FCR",
          label: "FCR",
          idValue: "192.168.1.6",
          serialNumber: "276271611239",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
      },
    ],
    rows: [
      {
        rowIndex: 1,
        column: [
          {
            shelf: {},
            camera: {},
          },
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 2,
        column: [
          {
            shelf: {},
            camera: {},
          },
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 3,
        column: [
          {
            shelf: {},
            camera: {},
          },
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 4,
        column: [
          {
            shelf: {},
            camera: {},
          },
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 5,
        column: [
          {
            shelf: {},
            camera: {},
          },
          {
            shelf: {},
            camera: {},
          },
        ],
      },
    ],
  },
  // Smart Cooler Single door (4)
  {
    name: "SmartSingleCooler",
    index: 3,
    gondolaType: "Cooler",
    shelfType: "Smart",
    rowCount: 5,
    columnCount: 1,
    rowWidth: 220,
    isCooler: true,
    isSingleCooler: true,
    isSelected: false,
    head: [
      {
        shelf: {},
        camera: {
          key: "HCL",
          label: "HCL",
          idValue: "192.168.1.1",
          serialNumber: "276271611234",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
        rightCamera: {
          key: "HCR",
          label: "HCR",
          idValue: "192.168.1.1",
          serialNumber: "276271611234",
          location: "1.2, 3.2, 4.2",
          isOnline: false,
        },
      },
    ],
    foot: [
      {
        shelf: {},
        camera: {
          key: "FCL",
          label: "FCL",
          idValue: "192.168.1.1",
          serialNumber: "276271611234",
          location: "1.2, 3.2, 4.2",
          isOnline: true,
        },
      },
    ],
    rows: [
      {
        rowIndex: 1,
        column: [
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 2,
        column: [
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 3,
        column: [
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 4,
        column: [
          {
            shelf: {},
            camera: {},
          },
        ],
      },
      {
        rowIndex: 5,
        column: [
          {
            shelf: {},
            camera: {},
          },
        ],
      },
    ],
  },
]

export default defaultDeviceFrameAll
